import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../i18n'; // Подключаем i18n
import { useParams, useNavigate } from 'react-router-dom';
import i18n from '../../i18n'; // Убедитесь, что i18n импортирован

const Rating = () => {
    const { t } = useTranslation();
    const { lang, orderId } = useParams();
    const navigate = useNavigate();
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');
    const [tip, setTip] = useState(false);
    const [selectedTip, setSelectedTip] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        console.log('useEffect called with lang:', lang, 'orderId:', orderId);
        if (['en', 'et'].includes(lang)) {
            i18n.changeLanguage(lang);
        } else {
            navigate(`/internal/rate/en/${orderId}`);
        }
    }, [lang, orderId, navigate]);

    const handleRatingChange = (newRating) => {
        setRating(newRating);
        if (newRating === 5) {
            setTip(true);
        } else {
            setTip(false);
            setSelectedTip(null);
        }
    };

    const handleTipSelect = (tipAmount) => {
        console.log('handleTipSelect called');
        console.log('Selected tip amount:', tipAmount);
        setSelectedTip(tipAmount);
    };

    const handleSubmit = async () => {
        setLoading(true);
        const payload = {
            orderID: orderId,
            rating,
            feedback: comment,
            tips: selectedTip || 0,
        };

        try {
            const response = await fetch('https://api.wiseclean.ee/api:56Z3lZ-0/old_order/rate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error('Error saving rating');
            console.log('selectedTip:', selectedTip);
            if (selectedTip) {
                navigate(`/external/payment/${lang}/${orderId}tips`);
            } else {
                setMessage(t('thankYouFeedback'));
                setSubmitted(true);
            }
        } catch (error) {
            console.error(error);
            setMessage('Error saving rating');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            {submitted ? (<>
                    <div style={styles.logoContainer}>
                        <img
                            src="/wise_clean_logo.png"
                            alt="Wise Clean Logo"
                            style={styles.logo}
                        />
                    </div>
                    <h1 style={styles.message}>{message}</h1>

                </>
            ) : (
                <>
                    <div style={styles.logoContainer}>
                        <img
                            src="/wise_clean_logo.png"
                            alt="Wise Clean Logo"
                            style={styles.logo}
                        />
                    </div>
                    <h1 style={styles.heading}>{t('howWasYourCleaning')}</h1>
                    <div style={styles.stars}>
                        {[1, 2, 3, 4, 5].map((star) => (
                            <span
                                key={star}
                                style={styles.star}
                                onClick={() => handleRatingChange(star)}
                            >
                                {star <= rating ? '★' : '☆'}
                            </span>
                        ))}
                    </div>
                    <textarea
                        placeholder={t('leaveYourFeedback')}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        style={styles.textarea}
                    />
                    {tip && (
                        <div style={styles.tipContainer}>
                            <h2 style={styles.tipHeading}>{t('addATip')}</h2>
                            <div style={styles.tipButtons}>
                                {[30, 20, 10, 5, 0].map((amount) => (
                                    <button
                                        key={amount}
                                        style={{
                                            ...styles.tipButton,
                                            backgroundColor: selectedTip === amount ? '#6CC8D9' : '#E0E0E0',
                                        }}
                                        onClick={() => handleTipSelect(amount)}
                                    >
                                        €{amount}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                    <button style={styles.doneButton} onClick={handleSubmit} disabled={loading}>
                        {loading ? 'Processing...' : t('done')}
                    </button>
                </>
            )}
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        fontFamily: 'Inter, Arial, sans-serif',
    },
    logoContainer: {
        position: 'absolute',
        top: '10px',
        left: '10px',
    },
    logo: {
        height: '60px',
        objectFit: 'contain',
    },
    heading: {
        fontWeight: 'bold',
        color: 'black',
        textAlign: 'center',
    },
    message: {
        fontWeight: 'bold',
        color: 'black',
        textAlign: 'center',
        margin: '100px 0',
        fontSize: '22px',
    },
    stars: {
        display: 'flex',
        gap: '5px',
        margin: '20px 0',
    },
    star: {
        cursor: 'pointer',
        fontSize: '25px',
    },
    textarea: {
        width: '90%',
        maxWidth: '500px',
        height: '120px',
        borderColor: '#CCCCCC',
        borderRadius: '10px',
        padding: '10px',
        margin: '20px 0',
    },
    tipContainer: {
        marginTop: '20px',
        textAlign: 'center',
    },
    tipHeading: {
        fontWeight: 'bold',
        color: 'black',
    },
    tipButtons: {
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
        marginTop: '10px',
    },
    tipButton: {
        backgroundColor: '#E0E0E0',
        color: 'white',
        borderRadius: '20px',
        padding: '10px 20px',
        cursor: 'pointer',
        border: 'none',
    },
    doneButton: {
        width: '90%',
        maxWidth: '500px',
        padding: '12px',
        backgroundColor: 'rgb(108, 200, 217)',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontFamily: 'freight-sans-pro, sans-serif',
        fontSize: '19px',
        fontWeight: '700',
        cursor: 'pointer',
        marginTop: '30px',
    }

};

export default Rating;